import React from 'react';
import { BLUE_HEADER_TEXT } from '../theme';
import { getStudentAvatar } from '../../shared/studentAvatar';
import './Header.css';
import StudentProfileSelector from '../components/StudentProfileSelector';
import { ParentLink } from '../ParentNavigation';

export default function Header({ overview, onOpenMiniTasks, avatarHref, pointsHref, paymentsHref, pointBalance, activePage, student360Href, students = [], studentId, onStudentChange }) {
  const student = overview?.student;
  const avatar = getStudentAvatar(student?.id, student?.avatar_id, student?.starter_emoji);
  const studentName = student ? `${student.name || ''} ${student.surname || ''}`.trim() : 'Öğrenci';
  const className = String(student?.class_name || '').trim();
  const classLabel = className ? `${className}${/sınıf/i.test(className) ? '' : ' Sınıfı'}` : '';
  const pageLabel = { avatar: 'Avatarım', points: 'Puanlarım', payments: 'Aboneliğim', miniTasks: 'Mini Görev' }[activePage] || 'Öğrenci360';
  const actions = [
    onOpenMiniTasks && { key: 'miniTasks', label: 'Mini Görev', icon: '🎯', onClick: onOpenMiniTasks },
    avatarHref && { key: 'avatar', label: 'Avatarım', icon: avatar.imageUrl
      ? <img src={avatar.imageUrl} alt="" decoding="async" style={{ width: 28, height: 28, objectFit: 'contain' }} />
      : avatar.avatar, href: avatarHref },
    pointsHref && { key: 'points', label: 'Puanlarım', icon: '⭐', href: pointsHref },
    (paymentsHref || activePage === 'payments') && { key: 'payments', label: 'Aboneliğim', icon: '🎟️', href: paymentsHref },
  ].filter(Boolean).map((action) => action.key === activePage && student360Href
    ? { key: 'student360', label: 'Öğrenci360', icon: '📊', href: student360Href }
    : action);

  return (
    <header className="student-landscape-header" data-testid="student360-header" style={{ position:'relative',
      backgroundColor:'#d7fff5',
      backgroundImage:'radial-gradient(circle at 84% 0%, rgba(255,255,255,0.72), transparent 30%), linear-gradient(115deg, #d7fff5, #c8f8ed 62%, #e3fbf0)',
      color:BLUE_HEADER_TEXT, padding:'12px 16px', borderBottom:'1px solid #a9eee1', zIndex:10 }}>
      <svg className="student-header-landscape" aria-hidden="true" viewBox="0 0 720 280" preserveAspectRatio="xMaxYMid slice">
        <path d="M0 88Q45 68 95 101T205 105V280H0Z" fill="#b9f4e7" />
        <path d="M720 112Q655 82 596 126T460 142V280H720Z" fill="#b9f4e7" />
        <path d="M0 162Q180 211 370 177T720 159V280H0Z" fill="#95e8cb" />
        <path d="M0 208Q178 160 351 211T720 192V280H0Z" fill="#bce9b8" />
        <path d="M0 251Q225 194 432 238T720 225V280H0Z" fill="#e3f5d6" />
        <path d="M153 42c5-17 24-20 33-7 14-9 32 2 31 15 20-2 26 22 7 26h-74c-21-2-17-31 3-34Z" fill="#fff" opacity=".85" />
        <path d="M497 70c6-19 28-23 39-7 16-10 37 2 36 18 23-2 30 25 8 30h-85c-24-3-20-36 2-41Z" fill="#fff" opacity=".85" />
        <g fill="#ffe17a" stroke="#ffd866" strokeWidth="5" strokeLinecap="round">
          <circle cx="646" cy="51" r="27" stroke="none" />
          <path d="M646 10v-7m0 96v-7m41-41h7m-96 0h7m70-29 5-5m-68 68-5 5m0-73 5 5m68 68-5-5" fill="none" />
        </g>
        <g fill="#53cda7">
          <path d="M12 208Q-3 145 15 158Q33 177 12 208Z" /><path d="M14 208Q20 155 40 169Q41 190 14 208Z" />
          <path d="M708 214Q678 153 696 147Q719 151 708 214Z" /><path d="M709 214Q715 153 732 169V218Z" />
          <path d="M385 186Q381 160 393 164Q404 168 398 185Q405 141 423 149Q436 157 425 187Q442 162 452 176V191Z" />
        </g>
      </svg>
      <div className="student-header-top" style={{ marginBottom:actions.length ? 12 : 0 }}>
      {activePage && student360Href && <ParentLink className="student-header-back" href={student360Href} aria-label="Öğrenci360’a dön">
        <svg aria-hidden="true" viewBox="0 0 24 24"><path d="m14 5-7 7 7 7" /></svg>
      </ParentLink>}
      <div data-testid="student-page-label" className="student-header-page-title">{pageLabel}</div>
      <div className="student-header-details">
      <StudentProfileSelector students={students} studentId={studentId || student?.id} onStudentChange={onStudentChange}>
      <div className="student-header-identity" data-testid="student360-header-identity">
        <div className="student-header-avatar" role="img" aria-label={`${studentName} avatarı`} style={{
          boxSizing:'border-box', borderRadius:'50%', background:avatar.bgColor,
          border:'3px solid #46dfce', display:'grid', placeItems:'center',
          overflow:'hidden', flex:'0 0 auto', boxShadow:'0 3px 10px rgba(24,154,143,0.17)',
        }}>
          {avatar.imageUrl ? <img src={avatar.imageUrl} alt="" decoding="async"
            style={{ width:'100%', height:'100%', objectFit:'contain' }} />
            : <span className="student-header-avatar-emoji">{avatar.avatar}</span>}
        </div>
        <div style={{ minWidth:0 }}>
          <div className="student-header-name">{studentName}{students.length > 1 && <span className="student-profile-chevron" aria-hidden="true">⌄</span>}</div>
          {classLabel && <div style={{ fontSize:15, fontWeight:700, color:'#465570', marginTop:3 }}>{classLabel}</div>}
        </div>
      </div>
      </StudentProfileSelector>
      {pointBalance != null && <div className="student-header-points" aria-label={`${pointBalance} kullanılabilir puan`}>
        <span aria-hidden="true">⭐</span><strong>{pointBalance}</strong><span>puan</span>
      </div>}
      </div>
      </div>
      {actions.length > 0 && (
        <nav aria-label="Öğrenci bağlantıları" style={{ display:'grid', gridTemplateColumns:`repeat(${actions.length}, minmax(0, 1fr))`, background:'#fff', borderRadius:20, minHeight:72, boxShadow:'0 8px 22px rgba(20,105,115,0.1)', overflow:'hidden', position:'relative' }}>
          {actions.map((action, index) => {
            const style = { display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', gap:3,
              minWidth:0, padding:'7px 3px', border:0, borderRight:index < actions.length - 1 ? '1px solid #e2e8f0' : 0,
              background:'transparent', color:BLUE_HEADER_TEXT, textDecoration:'none', cursor:'pointer', fontFamily:'inherit' };
            const content = <><span aria-hidden="true" style={{ fontSize:25, lineHeight:1, whiteSpace:'nowrap' }}>{action.icon}</span>
              <span style={{ fontSize:14, fontWeight:900, textAlign:'center', lineHeight:1.15 }}>{action.label}</span></>;
            return action.href
              ? <ParentLink key={action.label} href={action.href} aria-label={action.ariaLabel} style={style}>{content}</ParentLink>
              : <button key={action.label} type="button" onClick={action.onClick} style={style}>{content}</button>;
          })}
        </nav>
      )}
    </header>
  );
}
